import { render, staticRenderFns } from "./goal-setting.page.vue?vue&type=template&id=b80f6d10&scoped=true"
import script from "./goal-setting.page.vue?vue&type=script&lang=ts"
export * from "./goal-setting.page.vue?vue&type=script&lang=ts"
import style0 from "./goal-setting.page.vue?vue&type=style&index=0&id=b80f6d10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80f6d10",
  null
  
)

export default component.exports